import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=03d34cde&scoped=true&lang=css"

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d34cde"]])

export default __exports__